import Tabs, { Tab } from "./Tabs";

export default Tabs;
export { Tab };
